import { render, staticRenderFns } from "./VFairList.vue?vue&type=template&id=63b7f960&scoped=true&"
import script from "./VFairList.vue?vue&type=script&lang=js&"
export * from "./VFairList.vue?vue&type=script&lang=js&"
import style0 from "./VFairList.vue?vue&type=style&index=0&id=63b7f960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7f960",
  null
  
)

export default component.exports